import React from 'react'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import { Button, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
    width: 20
  }
}));

// based on https://github.com/rjsf-team/react-jsonschema-form/blob/master/packages/material-ui/src/RadioWidget/RadioWidget.tsx
const BooleanButtonsWidget = ({
  id,
  schema,
  options,
  value,
  required,
  disabled,
  readonly,
  label,
  onChange,
  formContext
}) => {
  const { enumOptions, enumDisabled } = options
  const classes = useStyles();

  const _onClick = ({ currentTarget }) => {
    const value = currentTarget.value !== 'false'
    onChange(value)
    if (schema.submitOn?.includes(value)) {
      formContext.formRef && setTimeout(() => formContext.formRef.current.submit(), 0)
    }
  }

  return (
    <FormControl fullWidth={true} required={required && (Boolean(label) || Boolean(schema.title))}>
      <FormLabel htmlFor={id} style={{ marginBottom: '0.5em' }}>{label || schema.title}</FormLabel>
      {(enumOptions).map((option, i) => {
        const itemDisabled = enumDisabled && (enumDisabled).indexOf(option.value) !== -1
        const button = (
          <Button value={`${option.value}`}
                  variant={value === option.value ? 'contained' : 'contained'}
                  color={value === option.value ? 'primary' : 'secondary'}
                  key={i}
                  onClick={_onClick} disabled={disabled || itemDisabled || readonly}
                  className={classes.button}
          >
            {`${option.label}`}
          </Button>
        )

        return button
      })}
    </FormControl>
  )
}

export default BooleanButtonsWidget
